<template>
  <b-table
    :data="data"
    draggable
    @dragstart="dragstart"
    @drop="drop"
    @dragover="dragover"
    @dragleave="dragleave"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="active" label="Ativo" numeric>
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
      </b-table-column>

      <b-table-column label="Título">{{ props.row.title }}</b-table-column>

      <b-table-column label="Respostas">
        <div
          v-for="answer in answers"
          :key="answer"
          class="answer"
          :class="{ correct: props.row.correct == answer }"
        >
          <span v-if="props.row[`answer_${answer}`]">{{
            props.row[`answer_${answer}`]
          }}</span>
        </div>
      </b-table-column>

      <b-table-column label="Opções">
        <router-link
          :to="`questions/${props.row.id}/edit`"
          tag="button"
          type="button"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </router-link>
        <button
          @click="onClickDeleteQuestion(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Excluir'"
          color="danger"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import TrainingQuestionService from '@/services/training-question.service';
import TrainingService from '@/services/training.service';
import DraggableTableMixin from '@/mixins/DraggableTableMixin';

export default {
  name: 'training-questions-table',
  mixins: [DraggableTableMixin],
  props: ['trainingId'],
  data: () => {
    return {
      data: [],
      answers: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    load(trainingId) {
      TrainingService.getQuestions(trainingId)
        .then(({ data: questions }) => (this.data = questions))
        .catch(() => this.toastify('Erro ao carregar perguntas.', 'error'));
    },
    onClickDeleteQuestion(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Pergunta',
        message:
          'Tem certeza que deseja <b>excluir</b> este pergunta? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Pergunta',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteQuestion(id),
      });
    },
    deleteQuestion(id) {
      TrainingQuestionService.delete(id)
        .then(() => {
          this.toastify('Pergunta excluída com sucesso.');
          this.load(this.trainingId);
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Pergunta.',
            'error'
          );
        });
    },
    onOrderChange(questionId, from, to) {
      this.data = this.reorderArray(this.data, from, to);
      this.saveOrder();
    },
    saveOrder() {
      const order = this.data.reduce((obj, question, index) => {
        return { ...obj, [question.id]: index + 1 };
      }, {});

      TrainingQuestionService.reorder(order)
        .then(() => this.toastify('Ordem atualizada com sucesso!'))
        .catch(() => this.toastify('Erro ao tentar atualizar ordem.', 'error'));
    },
  },
  mounted() {
    this.load(this.trainingId);
  },
};
</script>

<style lang="scss" scoped>
.answer {
  font-size: 0.9em;

  &.correct {
    font-weight: bold;
    color: var(--color-success);
  }
}
</style>
